<template>
  <img :src="getImgUrl()">
  <!-- <div class="card">
  </div> -->
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  methods: {
    getImgUrl() {
      let images = require.context('../assets/images/cards/', false, /\.svg$/)
      return images('./' + this.srcUrl + ".svg")
    }
  },
  computed: {
    srcUrl () {
      return `Card_${this.content.suit}_${this.content.number}`
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  background-color: #fff;
  border-radius: 5%;
  box-shadow: 0px 0px  3px #444;
  width: 100%;
  // max-width: 103px;
  // max-height: 136px;
}
</style>
